/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_MayInputs */

const en_better_studio_month_may = /** @type {(inputs: Better_Studio_Month_MayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May`)
};

/**
* | output |
* | --- |
* | "May" |
*
* @param {Better_Studio_Month_MayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_may = /** @type {((inputs?: Better_Studio_Month_MayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_MayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_may(inputs)
});